/**
 * Frontend Constants
 * Single source of truth for magic strings used across the frontend.
 */

// ━━━ PAGE ROUTING ━━━

export const PAGES = {
  MAIN: 'main',
  ADMIN: 'admin',
  SETTINGS: 'settings',
};

export const VIEWS = {
  HOME: 'home',
  STUDIO: 'studio',
  FAMILY_ARCHIVE: 'family',
};

export const SETTINGS_TABS = {
  PROFILE: 'profile',
  PREFERENCES: 'preferences',
  NOTIFICATIONS: 'notifications',
  SHARING: 'sharing',
  SUBSCRIPTION: 'subscription',
  FAMILY: 'family',
};

// ━━━ TRANSCRIPTION & AI STATUS ━━━

export const TRANSCRIPTION_STATUS = {
  NONE: 'none',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const AI_STATUS = {
  NONE: 'none',
  GENERATING: 'generating',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const TITLE_SOURCE = {
  TRANSCRIPTION: 'transcription',
  TEXT: 'text',
};

// ━━━ MEDIA TYPES ━━━

export const MEDIA_TYPES = {
  VIDEO: 'video',
  AUDIO: 'audio',
  TEXT: 'text',
  IMAGE: 'image',
  MIXED: 'mixed',
};

// ━━━ TRANSCRIPTION PREFERENCES ━━━

export const TRANSCRIPTION_PREFERENCE = {
  NEVER: 'never',
  ON_DEMAND: 'on_demand',
  ALWAYS: 'always',
};

// ━━━ FILTERS ━━━

export const ANSWER_FILTER = {
  SHOW_ALL: 'show all',
  UNANSWERED_ONLY: 'unanswered only',
  ANSWERED_ONLY: 'answered only',
  NEW_ONLY: 'new only',
};

export const DATE_FILTER = {
  NONE: 'none',
  LAST_WEEK: 'last-week',
  LAST_MONTH: 'last-month',
  SINCE: 'since',
  BETWEEN: 'between',
};

export const CATEGORY_FILTER = {
  ALL: 'all',
};

// ━━━ LOCAL STORAGE KEYS ━━━

export const STORAGE_KEYS = {
  TOKEN: 'token',
  LAST_ACTIVITY_PING: 'lastActivityPing',
};

// ━━━ SESSION STORAGE KEYS ━━━

export const SESSION_KEYS = {
  INVITATION_TOKEN: 'invitationToken',
  INVITATION_EMAIL: 'invitationEmail',
};

// ━━━ WEBSOCKET MESSAGE TYPES ━━━

export const WS_MESSAGES = {
  TRANSCRIPTION_UPDATE: 'transcription_update',
  TITLE_GENERATION_STARTED: 'title_generation_started',
  TITLE_UPDATE: 'title_update',
  ENHANCEMENT_STARTED: 'enhancement_started',
  ENHANCEMENT_UPDATE: 'enhancement_update',
  CONNECTED: 'connected',
  PONG: 'pong',
};

// ━━━ FOLLOWUP DISPLAY MODES ━━━

export const FOLLOWUP_DISPLAY_MODE = {
  INLINE: 'inline',
  POPUP: 'popup',
};
